/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";

/**
 *  Data file import forcely
 */
window.$(document).on('click', '.startDataImport', function (e) {
    e.preventDefault();
    window.toastr.remove();
    window.axios({
        method: "post",
        url: window.$(this).attr('link')
    })
    .then(function (response) {
        window.toastr.success(response.data.message, response.statusText);
        setTimeout(function () {
            window.location = '';
        }, 1500);
    })
    .catch(function (error) {
            window.toastr.error(error.response.data.message, error.response.statusText);
    });
});


/**
 * Delete Data file
 */
window.$(document).on('click', '.deleteDataFile', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = window.$(".dataScheduleTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".dataScheduleTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        console.log(err);
        return false;
    });

});

/**
 *  Data file store
 */
window.$(".dataUpload").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.$("#errors").html('');
    window.toastr.remove();
    window.$(".errors-block").addClass('d-none');
    
    //window.$('.dataUpload').attr('disabled', 'disabled');
    let formdata = new FormData($("form.dataUploadForm")[0]);
    window.axios({
        method: "post",
        url: window.$(".dataUploadForm").attr('action'),
        headers: { "Content-Type": "multipart/form-data" },
        data: formdata,
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = '';
            }, 1500);
        })
        .catch(function (error) {
            window.$('.dataUpload').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });

            } else if (error.response.status == 409) {
                window.$("#data_file").val(null);
                window.$(".errors-block").removeClass('d-none');
                window.$.each(error.response.data, function (key, value) {
                    window.$('#errors').html(value);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});




 
/**
 * data file table listing
 */

var table = window.$('.dataScheduleTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    order: [
    ],
    columns: [
        { data: 'id', name: 'id', "visible": false, },
        { data: 'restaurant', name: 'restaurant' },
        { data: 'data_type', name: 'data_type' },
        { data: 'path', name: 'path' ,  orderable: false, searchable: false},
        { data: 'status', name: 'status' },
        { data: 'created_at', name: 'created_at' },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ],
});
 




 

 

 

 